import type { CSSProperties } from 'preact'

export function ChevronIcon({ style }: { style?: CSSProperties } = {}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      style={{
        display: 'block',
        flexShrink: 0,
        width: '24px',
        height: '24px',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2,
        ...style,
      }}
    >
      <polyline points="6 9 12 15 18 9" fill="none" />
    </svg>
  )
}
